// Shopify events

document.addEventListener('shopify:section:select', (e)=>{
	if ( e.target.classList.contains('mount-popup') ) {
		e.target.querySelector('modal-box').show();
	}
});
document.addEventListener('shopify:section:deselect', (e)=>{
	if ( e.target.classList.contains('mount-popup') ) {
		e.target.querySelector('modal-box').hide();
	}
});

class CSSSlider extends HTMLElement {

	constructor(){

		super();

    this._touchScreen = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;
    const ua = navigator.userAgent.toLowerCase();
    this._ios15 = this._touchScreen && ua.includes('applewebkit') && ( ua.includes('os 15_') || ua.includes('version/15') );

		// create option object, from defaults
		this.o = {
			...{
				selector: '.css-slide', 
				snapping: true, 
        groupCells: false,
				autoHeight: false, 
				navigation: true,
				navigationDOM: `<span class="css-slider-button css-slider-prev" style="display:none">←</span>
					<span class="css-slider-button css-slider-next" style="display:none">→</span>`,
        thumbnails: true,
        thumbnailsDOM: `<div class="css-slider-dot-navigation" style="display:none"></div>`,
        indexNav: false,
        indexNavDOM: `<div class="css-slider-index-navigation"><span class="css-slider-current">1</span> / <span class="css-slider-total">1</span></div>`,
        watchCSS: false,
        undisplay: false,
        listenScroll: false
			}, ...JSON.parse(this.dataset.options)
		};

    // init slider or watch for css
    if ( ! this.o.watchCSS ) {
      this.initSlider();
    } else {
      this.RESIZE_WATCHER = debounce(()=>{
        const afterContent = window.getComputedStyle(this,':after').content;
        if ( afterContent.includes('css-slide') && !this.sliderEnabled ) {
          this.initSlider();
        } else if ( !afterContent.includes('css-slide') && this.sliderEnabled )  { 
          this.destroySlider();
        }
      }, 100);
      window.addEventListener('resize', this.RESIZE_WATCHER);
      this.RESIZE_WATCHER();
    }

	
	}

  destroySlider(){
    this.innerHTML = `${this.originalHTML}`;
    this.classList.remove('enabled');
    this.sliderEnabled = false;
    window.removeEventListener('resize', this.RESIZE_EVENT);
    window.removeEventListener('scroll', this.SCROLL_EVENT);
    window.removeEventListener('scroll', this.SCROLL_EVENT_ANIMATION);
  }

  initSlider(){

    // create custom events

    this._readyEvent = new CustomEvent('ready');
    this._changeEvent = new CustomEvent('change');
    this._scrollEvent = new CustomEvent('scroll');
    this._navEvent = new CustomEvent('navigation');
    this._pointerDownEvent = new CustomEvent('pointerDown');
    this._pointerUpEvent = new CustomEvent('pointerUp');

    // create slider structure

    this.classList.add('css-slider');
    this.originalHTML = this.innerHTML;
    this.innerHTML = `<div class="css-slider-viewport">
      <div class="css-slider-holder">
        <div class="css-slider-container">
          ${this.originalHTML}
        </div>
      </div>
    </div>`;


    
    // add css-slide to children, if it's not set

    if ( this.o.undisplay ) {
      this.querySelectorAll(`${this.o.selector}`).forEach((elm)=>{
        elm.style.display = 'block';
      })
    }

    if ( this.o.selector != '.css-slide' ) {
      this.querySelectorAll(`${this.o.selector}`).forEach((elm)=>{
        elm.classList.add('css-slide');
      })
    }

    // setup variables

    this.element = this.querySelector('.css-slider-holder');
    if ( this.o.groupCells ) {
      this.element.scrollLeft = 0;
    }

    this.items = this.querySelectorAll(`${this.o.selector}`);
    this.indexedItems = [];
    this.index = 0;
    this.length = this.items.length;
    this.windowWidth = window.innerWidth;

    this.querySelector('.css-slider-container').addEventListener('mousedown', e=>{
      e.preventDefault();
    });
    
    this.viewport = this.querySelector('.css-slider-viewport');
    if ( this.o.autoHeight ) {
      this.viewport.classList.add('auto-height');
    }

    // append navigation

    if ( this.o.navigation || this.o.thumbnails || this.indexNav ) {

      let container = document.createElement('div');
      container.classList.add('css-slider-navigation-container');
      container.innerHTML = `
        ${(this.o.navigation ? this.o.navigationDOM : '')}
        ${(this.o.thumbnails ? this.o.thumbnailsDOM : '')}
        ${(this.o.indexNav ? this.o.indexNavDOM : '')}`;

      if ( this.o.navigation ) {
        this.prevEl = container.querySelector('.css-slider-prev');
        this.prevEl.addEventListener('click', e=>{
          this.changeSlide('prev');
          this.dispatchEvent(this._navEvent);
        });
        this.nextEl = container.querySelector('.css-slider-next');
        this.nextEl.addEventListener('click', e=>{
          this.changeSlide('next');
          this.dispatchEvent(this._navEvent);
        });
      }

      if ( this.o.thumbnails ) {
        this.thumbnailsEl = container.querySelector('.css-slider-dot-navigation'); 
      }

      if ( this.o.indexNav ) {
        this.indexEl = container.querySelector('.css-slider-current');
        this.lengthEl = container.querySelector('.css-slider-total'); 
      }

      this.append(container);

    }

    if ( this.length > 1 ) {

      // observer for slides

      this.RESIZE_EVENT = debounce(()=>{
        if ( this.windowWidth != window.innerWidth && this.o.groupCells) {
          this.resetSlider();
        }
        if ( ! this.o.groupCells ) {
          this.checkSlide();
        }
        this.windowWidth = window.innerWidth;
      }, 100);
      window.addEventListener('resize', this.RESIZE_EVENT);
      this.resetSlider(true);    

      // dispatching scroll event, mostly for extra animations
      if ( this.o.listenScroll ) {
        this.SCROLL_EVENT_ANIMATIONS = (()=>{
          let slidesWidth = -this.querySelector('.css-slider-container').offsetWidth;
          this.items.forEach(elm=>{slidesWidth += elm.offsetWidth});
          this.progress = this.element.scrollLeft / slidesWidth;
          this.dispatchEvent(this._scrollEvent);
        });
        this.element.addEventListener('scroll', this.SCROLL_EVENT_ANIMATIONS, {passive:true});
      }

      this.SCROLL_EVENT = debounce(()=>{
        // checking selected index
        if ( ! this._sliderBlockScroll ) {
          const scrollItems = this.indexedItems.entries();
          const scrollArray = Array.from(scrollItems, elm => Math.abs(elm[1].offsetLeft-this.element.scrollLeft));
          const scrollDistance = Math.min(...scrollArray);
          const scrollIndex = scrollArray.indexOf(scrollDistance);
          /*if ( this.indexedItems[this.length-2].offsetLeft-this.element.scrollLeft < 0 ) {
            this.index = this.length - 1;
            this.checkSlide();
            this.dispatchEvent(this._changeEvent);
          } else */if ( scrollIndex != this.index ) {
            this.index = scrollIndex;
            this.checkSlide();
            this.dispatchEvent(this._changeEvent);
          }

        }
      }, 10);

      // mouse fallback for non-touch devices

      this.element.addEventListener('scroll', this.SCROLL_EVENT, {passive:true});

      if ( ! this._touchScreen && ! this.element.classList.contains('css-slider--singular') ) {
        this.element.addEventListener('mousedown', e=>{
          if ( ! this.element.classList.contains('css-slider--disable-dragging') ) {
            this.mouseX = e.screenX;
            this.element.classList.add('can-drag');
            this.element.classList.add('mouse-down');
          }
        });
        this.element.addEventListener('mouseup', e=>{
          this.element.classList.remove('mouse-down');
          this.element.classList.remove('can-drag');
          this.element.classList.remove('pointer-events-off');
        });

        this.element.addEventListener('mouseleave', e=>{
          this.element.classList.remove('mouse-down');
          this.element.classList.remove('can-drag');
          this.element.classList.remove('pointer-events-off');
        });

        this.element.addEventListener('mousemove', e=>{
          if ( this.element.classList.contains('can-drag') ) {
            this.element.classList.add('pointer-events-off');
            let direction = this.mouseX - e.screenX;
            if ( Math.abs(direction) > 1 ) {
              if ( direction > 0 ) {
                this.changeSlide('next');
                this.element.classList.remove('can-drag');
              } else if ( direction < 0 ) {
                this.changeSlide('prev');
                this.element.classList.remove('can-drag');
              }
            }
          }
        });

      }

      // helper for browser that don't support smooth scrolling

      if ( ! ( "scrollBehavior" in document.documentElement.style ) && ! this._touchScreen ) {
        this.element.classList.add('force-disable-snapping');
      }

    }

    // dispatch ready event

    this.classList.add('enabled');
    this.sliderEnabled = true;
    this.dispatchEvent(this._readyEvent);

  }

	changeSlide(direction, behavior='smooth'){

    // function that changes the slide, either by word (next/prev) or index

		if ( direction == 'next' ) {
      if ( this.index+1 < this.length ) {
        this.index++;
      }
    } else if ( direction == 'prev') {
      if ( this.index-1 >= 0 ) {
        this.index--;
      }
    } else if ( parseInt(direction) >= 0 ) {
      this.index = parseInt(direction);
    }

    this._sliderBlockScroll = true;
    if ( this._ios15 ) {
      this.element.classList.add('force-disable-snapping');
    }
    setTimeout(()=>{
      this._sliderBlockScroll = false;
      if ( this._ios15 ) {
        this.element.classList.remove('force-disable-snapping');
      }
    }, 500);

    this.checkSlide();

    this.element.scrollTo({
      top: 0,
      left: this.indexedItems[this.index].offsetLeft - parseInt(getComputedStyle(this.indexedItems[0]).marginLeft),
      behavior: behavior
    });
    this.dispatchEvent(this._changeEvent);

	}

	checkSlide(){  
    
    // checks slide after index change and updates navigation / viewport

    if ( this.o.navigation ) {
      this.prevEl.classList.remove('disabled');
      this.nextEl.classList.remove('disabled');
      if ( this.index == 0 ) {
        this.prevEl.classList.add('disabled');
      }
      if ( this.index == this.length - 1 ) {
        this.nextEl.classList.add('disabled');
      }
    }

    if ( this.o.thumbnails && this.thumbnails ) {
      this.thumbnails.forEach(elm=>{elm.classList.remove('active')});
      this.thumbnails[this.index].classList.add('active');
    }

    if ( this.o.indexNav ) {
      this.indexEl.textContent = this.index+1;
    }
		
    if ( this.o.autoHeight ) {
      this.viewport.style.height = this.indexedItems[this.index].offsetHeight + 'px';
    } 
    
    this.indexedItems.forEach((elm,i)=>{
      if ( i == this.index ) {
        elm.classList.add('css-slide-active');
      } else {
        elm.classList.remove('css-slide-active');
      }
    });

	}

	afterAppend(){
		this.items = this.querySelectorAll(`${this.o.selector}`);
	}

	resetSlider(nojump=false,resetIndex=true){

		let slidesWidth = 0,
        slidesPerPage = 0,
        page = 0,
        pages = 0,
        totalWidth = this.querySelector('.css-slider-container').offsetWidth,// - 20,
        hideNavigation = false;

    // reset entire slider

    this.indexedItems = [];
    this.element.classList.add('disable-snapping');

    // find out how many pages (slides there are now)

    this.items.forEach((elm, i)=>{
      elm.classList.remove('css-slide--snap');
      slidesWidth += elm.offsetWidth;
      if ( slidesWidth > totalWidth && slidesPerPage == 0 ) {
        slidesPerPage = i;
      }
    });

    if ( slidesPerPage == 0 ) {
      slidesPerPage = this.items.length;
      hideNavigation = true;
    }
    // set each slide for observer

    this.items.forEach((elm, i) => {
      if ( i % slidesPerPage == 0  ) {
        elm.classList.add('css-slide--snap');
        elm.setAttribute('data-index', page++);
      }
    });

    this.indexedItems = this.querySelectorAll('.css-slide--snap');
    if ( resetIndex ) {
      this.index = 0;
    }
    this.length = Math.ceil(this.items.length / slidesPerPage);

    // recreate navigation

    if ( this.o.thumbnails ) {
      this.thumbnailsEl.innerHTML = '';
      for ( let i = 0; i < this.length; i++ ) {
        let dot = document.createElement('span');
        dot.classList.add('css-slider-dot');
        dot.dataset.index = i;
        this.thumbnailsEl.appendChild(dot);
        dot.addEventListener('click', (e)=>{
          this.changeSlide(e.target.dataset.index);
        });
      }
      this.thumbnails = this.thumbnailsEl.querySelectorAll('.css-slider-dot');
    }

    if ( this.o.indexNav ) {
      this.indexEl.textContent = this.index+1;
      this.lengthEl.textContent = this.length;
    }

    // hide navigation if only one slide

    if ( hideNavigation ) {
      this.element.classList.add('css-slider--no-drag');
      if ( this.o.navigation ) {
        this.prevEl.style.display = 'none';
        this.nextEl.style.display = 'none';
      }
      if ( this.o.thumbnails ) {
        this.thumbnailsEl.style.display = 'none';
      }
    } else {
      this.element.classList.remove('css-slider--no-drag');
      if ( this.o.navigation ) {
        this.prevEl.style.display = 'block';
        this.nextEl.style.display = 'block';
      }
      if ( this.o.thumbnails ) {
        this.thumbnailsEl.style.display = 'block';
      }
    }

    this.checkSlide();

    if ( ! nojump ) {
      this.element.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      })
    }
    this.element.classList.remove('disable-snapping');

	}

}
customElements.define('css-slider', CSSSlider);

document.addEventListener('shopify:section:load', (e)=>{
  if ( e.target.classList.contains('mount-css-slider') && e.target.querySelector('css-slider') ) {
    e.target.querySelectorAll('css-slider').forEach(slider=>{if(slider.enabled)slider.resetSlider()});
  }
});

const slideUp = (target, duration) => {
	target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  setTimeout(()=>{
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}
const slideDown = (target, duration) => {
	target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;

  if (display === 'none')
    display = 'block';

  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  setTimeout(()=>{
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}


class SplitScreenSlider extends CSSSlider {

	constructor(){
		super();

		this.mount();
		this.RESIZE_SliderHelper = debounce(()=>{
			this.unmount();
			this.mount();
		}, 300);
		window.addEventListener('resize', this.RESIZE_SliderHelper, {passive:true});

	}

	mount(){

		this._currentScroll = window.scrollY;
		this._headerHeight = document.getElementById('site-header').offsetHeight;

		this._fullWidth = this.classList.contains('layout-full') ? true : false;

		this._scrollEnabled = true;

		this._screenHeight = Math.min(window.innerHeight, window.screen.availHeight);

		this.slides = this.querySelectorAll('.slider-item'),
		this.slidesMedia = this.querySelectorAll('.slider-item-media > div');
		this.slidesBlackArray = this.querySelectorAll('.slider-item-media-overlay');
		this.headings = this.querySelectorAll('.box__heading');

		this.slides.forEach((elm, key)=>{
			if ( key == 0 || window.scrollY >= this._getOffsetTop(elm) ) {
				this.slidesMedia[key].style.height = `100%`;
			} else {
				this.slidesMedia[key].style.height = `0`;
			}
		});

		this.addEventListener('ready', ()=>{
			this.slides = this.querySelectorAll('.slider-item');
			this.slidesMediaElements = this.querySelectorAll('.slider-item-media-element');
			this.addEventListener('scroll', ()=>{
				const scrollX = -this.element.scrollLeft;
				this.slides.forEach((slide,i)=>{
			    const media = this.slidesMediaElements[i];
			    if ( media ) {
			    	media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
			    }
		    });
			});
		});

		let previous = -1,
			currentOld = -1;

		this.SCROLL_SliderHelper = () => {

			const scrollTop = window.scrollY >= 0 ? window.scrollY : 0;
			const sliderTop = this._getOffsetTop(this);

			if ( this._scrollEnabled ) {

				let current = 0;

				if ( scrollTop + this._headerHeight - this._headerHeight < this._getOffsetTop(this) && ! this.classList.contains('back-to-normal') ) {
					this.classList.add('back-to-normal');
				}

				this.slides.forEach((elm, key)=>{
					if ( this._checkVisible(elm) ) {
						current = key;
					}
				});

				if ( current != currentOld ) {
					if ( this._currentScroll < scrollTop && currentOld > 0 ) {
						this._scrollMedia( current, this.slides[currentOld], this.slides[previous], this.slidesMedia[currentOld], this.slidesBlackArray[previous], this._screenHeight);
					} else if ( this._currentScroll > window.scrollY && currentOld > 0 ) {
						this._scrollMedia( current, this.slides[currentOld], this.slides[previous], this.slidesMedia[currentOld], this.slidesBlackArray[previous], 0);
					}
					currentOld = current;
					previous = current-1;
				}

				if ( current == 0 && scrollTop + this._screenHeight >= sliderTop + this.offsetHeight && ! this.classList.contains('back-to-normal') ) {
					this.classList.add('back-to-normal');
				} else if ( current > 0 ) {

					const scrollValue = ( scrollTop - sliderTop ) - this._screenHeight * ( current - 1 );
					if ( ! this.classList.contains('back-to-normal') ) {
						this._scrollMedia( current, this.slides[current], this.slides[previous], this.slidesMedia[current], this.slidesBlackArray[previous], scrollValue);

					}
					if ( scrollTop + this._screenHeight >= sliderTop + this.offsetHeight && ! this.classList.contains('back-to-normal') ) {
						this.classList.add('back-to-normal');
					} else if ( scrollTop + this._screenHeight < sliderTop + this.offsetHeight && this.classList.contains('back-to-normal' ) ) {
						this.classList.remove('back-to-normal');
					}

				}

			}

			this._currentScroll = scrollTop;

		}

		window.addEventListener('scroll', this.SCROLL_SliderHelper, {passive:true});
		this.SCROLL_SliderHelper();

	}

	unmount() {
		window.removeEventListener('scroll', this.SCROLL_SliderHelper);
	}

	_scrollMedia(index, currentSlide, previousSlide, currentSlideMedia, previousSlideOverlay, scrollValue) {

		if ( this._fullWidth ) {
			currentSlideMedia.style.clipPath = `polygon(0 ${window.innerHeight - scrollValue + 1}px, 100% ${window.innerHeight - scrollValue + 1}px, 100% 100%, 0% 100%)`;
		} else {
			currentSlideMedia.style.height = `${scrollValue}px`;
		}

		if ( previousSlideOverlay ) {
			previousSlideOverlay.style.opacity = `${Math.ceil( scrollValue * 30 / this._screenHeight ) / 100}`;
		}

	}

	_checkVisible(elm) {
	  const rect = elm.getBoundingClientRect();
	  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
	  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
	}

	_getOffsetTop(elm) {
		if (!elm.getClientRects().length) {
      return 0;
    }
    const rect = elm.getBoundingClientRect();
    const win = elm.ownerDocument.defaultView;
    return rect.top + win.pageYOffset;
	}

}
customElements.define('split-screen-slider', SplitScreenSlider);
